module.exports = {"430371001":"板塘街道","430371002":"双马街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430371.json
// module id = 1828
// module chunks = 0